<template>
    <div class="result-count">{{ count }} results</div>
</template>

<script>
    import {EventBus} from "../event-bus";

    export default {
        data() {
            return {
                count: 0
            }
        },
        mounted() {
            let vm = this;
            EventBus.$on('posts-total', function(total) {
                if (total > 0) {
                    vm.count = total;
                };
            })
        }
    }
</script>